export const GET_MESSAGES_REQUEST = "GET_MESSAGES_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_MESSAGE = 'INSERT_MESSAGE'
export const DELETE_MESSAGE = 'DELETE_MESSAGE'